import {React} from 'react';
import { useState } from 'react'; 
//import Form from 'react-bootstrap/Form';
import { Formik, Form } from 'formik';
import * as Yup from 'yup';
import  dayjs  from 'dayjs';
import {Box, Typography, Stack, Link} from '@mui/material/';
import axios from 'axios';
import { createRoot } from 'react-dom/client';

import { NewTextField } from './components/NewTextField';
import { DatePicker } from './components/DatePicker';
import { AlertBox } from './components/AlertBox';
import Button from './components/Newbutton';

import ReCAPTCHA from "react-google-recaptcha";
import mainLogo from'./accet/mu.jpg';
import RightTitleBox from './components/RightTitleBox';

const initialValues={
    email:'',
    //email:'fahmed@metrouni.edu.bd',
    partOne:'',
    partTwo:'',
    partThree:'',
    //studentID:'143-116-029',
    dob:dayjs()
    //whatsappNO:'Please Enter a Valid Whatsapp Number to Receive the OTP'
}

const App =({token, URL, PORT}) => {
    //console.log(token);
    //const [URL, PORT] = useField(props);

    const validate = Yup.object({
        email: Yup.string().email().required(),
        partOne: Yup.string().required().max(3).matches('[0-9][0-9][0-9]'),
        partTwo: Yup.string().required().max(3).matches('[0-9][0-9][0-9]'),
        partThree: Yup.string().required().max(3).matches('[0-9][0-9][0-9]'),
        //dob: Yup.string().required()
    });

    const [formValues, setformValues] = useState(initialValues);
    const [loader, setLoader] = useState('Submit');
    const [capValue, setCapValue] = useState(null);   

    const onChange=(value)=> {
      //  console.log("Captcha value:", value);
        setCapValue(value);
      }

  return (
    <Formik
        initialValues={initialValues}

        validationSchema={validate}
        
        onReset ={
            ()=>{//alert("Bismillah")
                    setformValues(initialValues);
                    
                       const list = document.getElementById('result');
                       if (list.hasChildNodes()) {
                        list.removeChild(list.children[0]);
                      
                      
                       
                        setLoader('Submit');
                }   
            }
        }

        onSubmit ={async (e, onSubmitProps) =>{

        //    console.log("Captcha value 2:",capValue);

            //console.log('Form data',e);
          //  console.log('submit props',onSubmitProps);
            setLoader('Sending..');
            
            if(!capValue)
            {
                try{
                    const root =  createRoot(document.getElementById('result'));
                    root.render(<AlertBox type='warning' msg="Please select Captcha !!"/>);
                   //document.getElementById('result').innerHTML=<AlertBox type='warning' msg="Please select Captcha !!"/>;
                    setLoader('Submit');
                }
                catch(e){
                    console.log("error:",e);
                }
                            
            }
            else{
                try{

                    var date = document.getElementById(":r3:");
                    //console.log(`the Date is: ${date.value}`);
                    const param = {
                        
                        email: e.email,
                        studentID:e.partOne+"-"+e.partTwo+"-"+e.partThree,
                        dob:date.value
                    }
            //        console.log(param);

                    const axiosConfig = {
                        headers: {
                            'Content-Type': 'application/json;charset=UTF-8',
                            "Access-Control-Allow-Origin": "*",
                            "Authorization":'Bearer '+token
                        }
                      };
              //------------------------------------post request------------------------------------------      
                    const res = await axios.post(`${URL}:${PORT}/apix420`,param,  axiosConfig)
                    .then((res)=>{
                        
              //          console.log(res);
                        
                        
                        //console.log('submit props',onSubmitProps);
                    // alert(res.status);
                                            

                        if (res.status===200)
                        {
                            setLoader('Submit');
                            
                            try{
                                const root = createRoot(document.getElementById('result'));
                                root.render(<AlertBox type='success' msg={res.data.status}/>);
                                                        
                            }
                            catch(e){
                                console.log("error:",e);
                            }

                            // onSubmitProps.resetForm(initialValues); 
                        }   

                        //setformValues(initialValues);
                        
                    })
                    .catch((err) => {
                        console.log(err.message);
                });
                
            }
            catch(err) {
                console.error(`The error Message is:${err.message}`);
            }
        }
        }
    }    
        
    >
        
    
    {formik =>(
        <Box
            sx={{
                display:'flex',
                boxShadow:'none',
                borderRadius:'20px',
                //display:'flex',
                justifyContent:'center',
                alignItems:'center',
                width:{xs:'665px', md:'700px'},
                //height:'326px',
                margin:'auto'
            }}
            >
            <Box 
            sx={{
                boxShadow:'none',
                borderRadius:'20px',
                //display:'flex',
                justifyContent:'center',
                alignItems:'center',
                width:{xs:'365px', md:'420px'},
                //height:'326px',
                margin:'auto',
                padding:'0px 5px 0px 0px'
            }}>
                <Stack 
                    direction="row" 
                    
                    p={0}
                    sx={{ position: 'sticky', background:'#ffffff', top:0, display: 'flex', justifyContent: 'flex-end'}}
                    >
                    <Link href="http://www.metrouni.edu.bd" 
                        style={{}}>
                        <img src={mainLogo} alt="logo" height={80} />
                    </Link>
                </Stack>
                <Typography variant="h5" mt='10px' mb="20px"> Student's Result Verification System</Typography>
                <div id="result"></div>
                <Form > 
                    
                    
                    <h5 className='legend'>Student's ID [9 digits i.e. 000-000-000]</h5>
                    <Box
                        sx={{
                            display:'flex',
                            width: '365',
                        zIndex:2,
                            maxWidth: '100%',
                            border:'0px solid #adadaf',
                            p:'10px 2px 2px 2px',
                            mb:'12px',
                            borderRadius: '4px',
                            
                        }}
                    >
                        
                        <NewTextField label="000" name="partOne"  />
                        <Typography variant="h5" ml="5px" mt="20px" mr="5px">-</Typography> 
                        <NewTextField label="000" name="partTwo" />
                        <Typography variant="h5" mt="20px" ml="5px" mr="5px">-</Typography> 
                        <NewTextField label="000" name="partThree" />
                    </Box>
                    
                    <DatePicker label="Data Of Birth" name="dob" />
                    <NewTextField label="Your Email Address" name="email"  />
                    <Box
                        sx={{
                            width: '100%',
                            paddingTop: '10px',
                            paddingBottom: '20px',
                            maxWidth: '100%',
                        }}
                    >
            <ReCAPTCHA
            sitekey="6Le1gK0iAAAAAEqe9ve_CmIesxWj0V_wkixRwMQv"
            onChange={onChange}
            
            
                autoComplete='off'
                    />
            
        </Box>
                <Stack 
                sx={{
                    width: '100%',
                    paddingTop: '10px',
                    paddingBottom: '20px',
                    maxWidth: '100%',
                }}
                
                    justifyContent="center"
                
                direction="row" spacing={30}>
 
                    <Button label="Reset" type="reset" />
                    <Button label={loader}  type="submit" />
                </Stack>        
                </Form>
                
                </Box>
                <RightTitleBox/>
            </Box>   
            
            ) }
            
    </Formik>
    
  );
}

export default App;